import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  RESET_FILTER_SELECTED,
  SET_DATES,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_FILTERS_SUCCESS,
  UPDATE_SELECTED_FILTER,
  GET_PIE_CHART_BY_NAME,
  FETCH_CHART_SUCCESS,
  SET_ALL_SITES_MODE,
  UPDATE_REFERRAL_TOGGLE,
  SET_LOADING_FILTERS,
  UPDATE_FILTERS_SUCCESS
} from "./DemographicsSagas";

export const initialState = {
  currentUser: {},
  isAllSitesMode: false,
  pieChartsData: [],
  chartsData: {
    tableData: {
      isLoading: false,
      content: {}
    }
  },
  isLoading: true,
  isLoadingFilters: false,
  updatesLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  selectedFilters: {
    client_types: [],
    age_groups: [],
    birth_months: [],
    last_visits_months: [],
    genders: [],
    selected_categories: [],
    zip_codes: [],
    group_by: { id: 1, name: "Not Grouped" }
  },
  filters: {},
  referralCategory: false,
  referralCategoryAfterUpdate: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_LOADING_FILTERS]: (state, action) => ({
      ...state,
      isLoadingFilters: action.payload
    }),
    [SET_ALL_SITES_MODE]: (state, action) => ({
      ...state,
      isAllSitesMode: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: { ...state.filters, group_by: { id: 1, name: "Not Grouped" } },
      referralCategory: initialState.referralCategory
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    }),
    [GET_PIE_CHART_BY_NAME]: (state, action) => {
      const { data, name } = action.payload;
      const chartData = [["Name", "Value"], ...data];
      return {
        ...state,
        pieChartsData: {
          ...state.pieChartsData,
          [name]: chartData
        }
      };
    },
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartsData: {
        ...state.chartsData,
        ...action.payload
      },
      referralCategoryAfterUpdate: state.referralCategory
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: {
        ...action.payload
      },
      selectedFilters: {
        ...action.payload,
        group_by: { id: 1, name: "Not Grouped" }
      }
    }),
    [UPDATE_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: {
        ...state.filters,
        selected_categories: action.payload.selected_categories,
        group_by: action.payload.group_by
      },
      selectedFilters: {
        ...state.selectedFilters,
        group_by: initialState.selectedFilters.group_by,
        selected_categories: action.payload.selected_categories
      }
    }),
    [UPDATE_SELECTED_FILTER]: (state, action) => {
      const { data, name } = action.payload;
      return {
        ...state,
        filtersDirty: true,
        selectedFilters: {
          ...state.selectedFilters,
          [name]: data
        }
      };
    },
    [UPDATE_REFERRAL_TOGGLE]: (state, action) => ({
      ...state,
      referralCategory: action.payload,
      filtersDirty: true
    })
  },
  initialState
);
